import dJSON from 'dirty-json';

const moduleSelector = '.content-cards';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.content-cards__grid').insertAdjacentHTML('beforeend', /* html */ `
          <div class="content-cards__item">
            <h3 class="content-cards__title">${item.title}</h3>
            <div class="content-cards__text">${item.text}</div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
